import { render } from "./list-skeleton.vue?vue&type=template&id=3b21b2bc&ts=true"
import script from "./list-skeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-skeleton.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/list-skeleton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b21b2bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b21b2bc', __exports__)) {
    console.log('reload')
    api.reload('3b21b2bc', __exports__)
  }
  
  module.hot.accept("./list-skeleton.vue?vue&type=template&id=3b21b2bc&ts=true", () => {
    console.log('re-render')
    api.rerender('3b21b2bc', render)
  })

}


export default __exports__